<template>
  <div class="dataPage">
    <LayInfo
      :userModel="userModel"
      @longDo="longDo"
      @shortDo="shortDo"
      :isCanEdite="isCanEdite"
    ></LayInfo>
    <LayAnnotationList
      :annotationList="annotationList"
      @mouseOutInput="mouseOutInput"
      @addItem="addItem"
      @deleteDo="deleteDo"
      :isCanEdite="isCanEdite"
    ></LayAnnotationList>
    <div class="download-box">
      <div class="line"></div>
      <el-input
        class="download-left"
        v-model="downloadFile.name"
        :readonly="!isCanEdite"
      ></el-input>
      <el-button class="btn" @click="downloadDo">Download</el-button>
    </div>
    <div class="databuilder-box" v-show="showDataBuilder">
      <div class="line"></div>
      <div class="left">Databuilder</div>
      <div class="right">
        <a :href="dataBuilderUrl" target="_blank">{{ dataBuilderUrl }}</a>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getQueryStatus,
  getPageUserByUserId,
  getNewOSSUrl,
  markLongLive,
  updateAnnotation,
} from "@/request/api";
import { ResourceType } from "@/ginkgo-grpc/jslang/proto/services/rbf_service_pb";
import LayInfo from "@/components/LayInfo.vue";
import LayAnnotationList from "@/components/LayAnnotationList.vue";
import { downloadByUrl } from "@/utils/DownLoad";
import moment from "moment";
export default {
  name: "dataPage",
  data() {
    return {
      lineColor: "#FBAD15",
      iconImg: require("@/assets/data-normal-icon.png"),
      isSelected: false,

      downloadFile: {
        name: "",
        fileUrl: "",
      },
      userModel: {
        name: "",
        time: "",
        type: 0,
      },
      annotationList: [],
      showDataBuilder: false,
      dataBuilderUrl: "",
      fileModel: {},
      resourceId: "",
      isCanEdite: false,
    };
  },
  computed: {
    showUrl() {
      return this.downloadFile.fileUrl?.length > 0;
    },
  },
  methods: {
    deleteDo() {
      this.updateAnnotationData();
    },
    addItem() {
      console.log("addItem");
    },
    async updateAnnotationData() {
      await updateAnnotation({
        resourceId: this.resourceId,
        type: ResourceType.DATA,
        list: this.annotationList,
      });
    },
    mouseOutInput() {
      console.log("mouseOutInput");
      this.updateAnnotationData();
    },
    async longDo() {
      this.userModel.type = 1;
      this.updateLongLive({
        longLive: true,
        resourceId: this.resourceId,
        type: ResourceType.DATA,
      });
    },
    async shortDo() {
      this.userModel.type = 0;
      this.updateLongLive({
        longLive: false,
        resourceId: this.resourceId,
        type: ResourceType.DATA,
      });
    },
    async updateLongLive(item) {
      await markLongLive(item);
      this.$message.success("change successfully");
    },
    mouseOver(item) {
      item.img = require("@/assets/data-select-icon.png");
      item.isSelected = true;
    },
    async downloadDo() {
      console.log("downloadDo");
      const url = await getNewOSSUrl(
        this.fileModel?.bucket,
        this.fileModel?.key,
        this.fileModel.originname
      );
      console.log("url = ", url);
      this.downloadFile.fileUrl = url;
      console.log("this.fileModel?.originname =", this.fileModel?.originname);
      downloadByUrl(url, this.fileModel?.originname);
    },
  },
  components: {
    LayInfo,
    LayAnnotationList,
  },
  async created() {
    const param = this.$route.params;
    const id = param.id;
    this.resourceId = id;
    const data = await getQueryStatus(id, ResourceType.DATA);
    console.log("data = ", data);
    let title = ""
    if (data.data?.annotationsMap) {
      const mapList = [...data.data?.annotationsMap]
      title = this.$parent.$parent.getTitle(mapList)
    }
    document.title = `aqua.data${title}`
    
    const createTime = moment(
      (data.data?.creationtime.seconds +
        data.data?.creationtime.nanos / Math.pow(10, 9)) *
        1000
    ).format("YYYY-MM-DD HH:mm:ss");
    console.log("data.data?.committer = ", data.data?.committer);
    const user = await getPageUserByUserId(data.data?.committer);
    console.log("user ==== ", user);
    this.userModel.name = user.user?.nickname;
    this.userModel.time = createTime;
    this.userModel.type = data.data?.retention;
    this.isCanEdite = localStorage.getItem('userId') == data.data?.committer
    for (const map of data.data?.annotationsMap) {
      const item = {
        keyWord: map[0],
        keyValue: map[1],
        isSelected: false,
        img: require("@/assets/data-normal-icon.png"),
      };
      this.annotationList.push(item);
    }
    console.log("this.annotationList = ", this.annotationList);
    this.fileModel = data.data?.ossfile;
    this.downloadFile.name = data.data?.ossfile?.originname;

    const href = window.location.href.split("/benchmark").shift();
    if (data.data?.builderid) {
      this.dataBuilderUrl =
        href + "/benchmark/data-builder/" + data.data?.builderid;
      this.showDataBuilder = true;
    }
  },
};
</script>
<style lang='less' scoped>
.dataPage {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 50px;
}

.download-box {
  display: flex;
  background-color: #fff;
  padding: 10px 30px 10px 0px;
  align-items: center;
  margin-top: 30px;

  .line {
    width: 5px;
    height: 40px;
    background-color: #fbad15;
  }

  .download-left {
    margin-left: 30px;
    display: flex;
    width: 300px;
    :deep(.el-input__wrapper) {
      border: 0;
      background-color: #ecf2fe;
      width: 300px;
      box-shadow: none;
    }
  }

  .download-url {
    background-color: #f5f5f5;
    height: 40px;
    display: flex;
    align-items: center;
    border-radius: 3px;
    font-size: 14px;
    width: 100%;
    margin-left: 40px;
    width: calc(100% - 500px);
    // padding: 0px 10px;
    padding-left: 10px;
    padding-right: 10px;

    line-height: 40px;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .btn {
    background-color: #fbad15;
    border-radius: 20px;
    height: 40px;
    color: #fff;
    margin-left: 40px;
  }
}

.databuilder-box {
  width: 100%;
  height: 60px;
  background-color: #fff;
  margin-top: 20px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  .line {
    width: 5px;
    height: 40px;
    background-color: #fbad15;
  }
  .left {
    width: 300px;
    display: flex;
    align-items: center;
    margin-left: 30px;
    color: #383838;
    font-size: 16px;
    font-weight: 700;
  }
  .right {
    width: calc(100% - 450px);
    background-color: #f5f5f5;
    height: 40px;
    margin-left: 40px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    padding-left: 10px;
    padding: 0px 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    a {
      text-decoration: none;
      font-size: 14px;
      font-weight: 400;
      color: #0052d9;
    }
  }
}
</style>